import { UserState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const defaultState: UserState = {
  pid: '',
  memberships: [],
  validPassportForCurrentStation: false,
  validPassport: false,
  first_name: '',
  last_name: '',
  email: '',
  vppa_accepted: false,
  vppa_last_updated: '',
  vppa_status: '',
  has_memberships: false,
  ignoreIsPlayable: false,
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case 'UPDATE_USER_PROFILE':
      return { ...state, ...action.payload }
    case 'ACTIVATE_TEMPORARY_PASSPORT':
      return {
        ...state,
        validPassport: true,
        ignoreIsPlayable: true,
        validPassportForCurrentStation: true,
      }
    case 'ACTIVATE_TEMPORARY_VPPA':
      return {
        ...state,
        vppa_status: 'accepted',
        vppa_accepted: true,
        ignoreIsPlayable: true,
      }
    case 'DISABLE_TEMPORARY_SETTINGS':
      return { ...state, ignoreIsPlayable: false }
    case 'UPDATE_USER_STATION':
      return {
        ...state,
        validPassportForCurrentStation: state.memberships.some(
          (station) => station.call_sign === action.payload
        ),
      }
    case 'SIGN_OUT':
      return { ...defaultState }
    default:
      return state
  }
}
